export class ContractTypeModel {
  id: number;
  cod: string;
  description: string;
  startNumAnnoMese: string;
  endNumAnnoMese: string;
  checked: boolean;


  constructor(id?: number, cod?: string, description?: string, checked?: boolean,
              startNumAnnoMese?: string, endNumAnnoMese?: string) {
    this.cod = cod;
    this.id = id;
    this.description = description;
    this.checked = checked;
    this.startNumAnnoMese = startNumAnnoMese;
    this.endNumAnnoMese = endNumAnnoMese;
  }
}
